export const GET_APP_INTGERATION_CONFIG_SCHEMA = 'GET_APP_INTGERATION_CONFIG_SCHEMA';
export const UPDATE_APP_INTEGRATION_CONFIG = 'UPDATE_APP_INTEGRATION_CONFIG';